export default "__VITE_ASSET__BlqhCLTQ__"